import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  const isArabic = i18n.language === 'ar';

  const sections = [
    {
      title: t('Privacy_Who_We_Are_Title'),
      content: [t('Privacy_Who_We_Are_1'), t('Privacy_Who_We_Are_2')],
    },
    {
      title: t('Privacy_Data_Collected_Title'),
      content: [
        t('Privacy_Data_Collected_1'),
        t('Privacy_Data_Collected_2'),
        t('Privacy_Data_Collected_3'),
      ],
    },
    {
      title: t('Privacy_Use_Of_Data_Title'),
      content: [t('Privacy_Use_Of_Data_1')],
    },
    {
      title: t('Privacy_Cookies_Title'),
      content: [
        t('Privacy_Cookies_1'),
        t('Privacy_Cookies_2'),
        t('Privacy_Cookies_3'),
        t('Privacy_Cookies_4'),
      ],
    },
    {
      title: t('Privacy_Embedded_Content_Title'),
      content: [t('Privacy_Embedded_Content_1')],
    },
    {
      title: t('Privacy_Data_Retention_Title'),
      content: [t('Privacy_Data_Retention_1'), t('Privacy_Data_Retention_2')],
    },
    {
      title: t('Privacy_Changes_Title'),
      content: [t('Privacy_Changes_1')],
    },
    {
      title: t('Privacy_Other_Websites_Title'),
      content: [t('Privacy_Other_Websites_1')],
    },
    {
      title: t('Privacy_Law_Jurisdiction_Title'),
      content: [t('Privacy_Law_Jurisdiction_1')],
    },
  ];

  return (
    <div style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <section className="privacypolicy_heros">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="main-title">
                <h2>{t('Privacy_Policy')}</h2>
                <p>{t('Trust. Expertise. Results.')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="px-3 px-md-5 mt-5">
        <div className="privacy-box p-4 bg-light rounded-0">
          {sections.map((section, idx) => (
            <section key={idx} className="mb-5 terms-box">
              <h5 className="fw-semibold mb-3">{section.title}</h5>
              {section.content.map((para, i) => (
                <p className="text-muted" key={i}>
                  {para}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
